import { useTranslation } from "next-i18next";

const BillOfSaleIntroInfo = () => {
  const { t } = useTranslation(["billOfSalePage"]);

  type IntroInfo = {
    key: string;
    title: string;
    content: string;
  };

  const introInfos: IntroInfo[] = [
    {
      key: "buyer_seller_details_intro",
      title: t("billOfSalePage:buyer_seller_details_intro"),
      content: t("billOfSalePage:intro_info_buyer_seller_details"),
    },
    {
      key: "vehicle_info_intro",
      title: t("billOfSalePage:vehicle_info"),
      content: t("billOfSalePage:intro_vehicle_info"),
    },
    {
      key: "generate_pdf_intro",
      title: t("billOfSalePage:generate_pdf"),
      content: t("billOfSalePage:intro_info_generate_pdf"),
    },
  ];

  return (
    <>
      <div className="hidden lg:block items-center m-12">
        <h3 className="p-4 mr-5">
          {t("billOfSalePage:intro_info_detail_heading")}
        </h3>
      </div>
      {introInfos.map((info, index) => {
        return (
          <div key={info.key} className="items-center m-12">
            <div className="flex">
              <div className="w-[10%] p-4 mr-5">
                <div className="bg-white inline-flex items-center justify-center rounded-full h-10 w-10">
                  <span className="text-center rounded-full font-medium text-white bg-primary-bold h-6 w-6">
                    {index + 1}
                  </span>
                </div>
              </div>
              <div className="w-full p-4">
                <h3 className="mb-3">{info.title}</h3>
                <span className="text-gray-500 body-4">{info.content}</span>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default BillOfSaleIntroInfo;
